import { render, staticRenderFns } from "./ExpiringInventory.vue?vue&type=template&id=f5ddb438&"
import script from "./ExpiringInventory.vue?vue&type=script&lang=js&"
export * from "./ExpiringInventory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports